import React, { MouseEvent } from 'react';
import { BellOutlineMedium } from '@blueprint/icons';
import { StyledLeftButtonWithIcon } from './MobileQuickMenu.styles';
import { AjaxLinkClickProps } from 'search/AlertPanel/AlertPanel.types';

const createAlertText = 'Create email alert';

type Props = {
    onAjaxLinkClick?: AjaxLinkClickProps;
    trackingEventCategory: string;
    trackingEventLabel: string;
};

const CreateNotificationButton: React.FC<Props> = ({
    onAjaxLinkClick,
    trackingEventCategory,
    trackingEventLabel
}) => {
    const onClickHandler = (event: MouseEvent<HTMLElement>) => {
        onAjaxLinkClick &&
            onAjaxLinkClick(event, trackingEventCategory, trackingEventLabel);
    };

    return (
        <StyledLeftButtonWithIcon
            variant="secondary"
            isFullWidth
            data-testid="create-alert"
            onClick={onClickHandler}
        >
            <BellOutlineMedium />
            {createAlertText}
        </StyledLeftButtonWithIcon>
    );
};

export default CreateNotificationButton;
